import { Cast } from '@/modules/casts/classes'
import { useCurrentTeam } from '@/modules/teams/compositions'
import { computed, ComputedRef, Ref } from '@vue/composition-api'
import useSceneLayouts from './sceneLayouts'
import { KeyDict } from '@/types'
import { LayoutBox } from '@/types/layouts'
import { AssetType } from '@/types/assets'
import { UserProfile } from '@/types/users'

const useSceneCaster = (cast: Ref<Cast|null>, sceneId: Ref<string|null>, casterId: Ref<string|null>) => {

  const { currentTeamMembers } = useCurrentTeam()

  const caster = computed(() => cast.value?.invited_casters[casterId.value ?? ''] ?? null)
  const casterUserId = computed(() => caster.value?.userId ?? '')
  const casterProfile: ComputedRef<UserProfile|null> = computed(() =>
    currentTeamMembers.value[casterUserId.value] ?? null)
  const casterName = computed(() => casterProfile.value?.displayOrFirstLastName ?? 'Unknown caster')
  const isCasterOnline = computed(() => cast.value ? cast.value.online_sessions[casterUserId.value]?.length > 0 : false)

  const { sceneLayout } = useSceneLayouts(cast, sceneId)
  // eslint-disable-next-line complexity
  const sceneCasterBoxes = computed(() => {
    const map: KeyDict<LayoutBox> = {}
    if (!cast.value || !sceneId.value) return map
    const layoutBoxes = sceneLayout.value?.boxes ?? {}
    const contents = Object.values(cast.value?.getSceneContents(sceneId.value) ?? {})
    for (const content of contents) {
      if (content.active && content.type === AssetType.Caster && !!content.user) {
        map[content.user] = layoutBoxes[content.box]
      }
    }
    return map
  })
  const casterBox: ComputedRef<LayoutBox|null> = computed(() => sceneCasterBoxes.value[casterId.value ?? ''] ?? null)

  return {
    caster,
    casterBox,
    casterName,
    casterUserId,
    isCasterOnline
  }
}

export default useSceneCaster
